// extracted by mini-css-extract-plugin
export default {"callbackContainer":"QMPLoginCallback_callbackContainer__v1hpG","loginCallback":"QMPLoginCallback_loginCallback__593Oz"};